<div >
    <app-breadcrumb
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>

    <app-admin-navigation
        [params]="{page: 'SYMPTOMS'}" [type]="'SELF_REPORT'">
    </app-admin-navigation>

    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header__title">
                    {{ 'Symptom Management' | translate }}
                </div>
                <div class="card--box__header--action text-xs-right">
                    <span class="card--box__header__action float-xs-right">
                        <button type="button" class="btn btn-link  card--box__header__action__button" (click)="openFormModal({action: 'create', title: 'Add Symptom', url: '/symptoms'});">
                            <i class="fas fa-plus-circle"></i>
                            <span class="hidden-sm-down">{{ 'Add Symptom' | translate}}</span>
                        </button>
                    </span>
                </div>
            </div>
            <div class="card-block card--box__block">
                <div class="row">
                    <div class="col-xs-7 col-xl-6">
                        <div class="sprite card--box__search">
                            <!--user search custom results-->
                            <ng-template #searchList let-model="item" let-index="index">
                                {{ model.name }}
                            </ng-template>
                            <!--user search input (reserved for later ticket)-->
                            <input [(ngModel)]="searchInfo.keyword" class="form-control card--box__search__input"
                                placeholder="{{ 'Search by name' | translate }}" (keyup.enter)="searchItems()" />
                        </div>
                    </div>
                    <!--search filters-->
                    <div *ngIf="filterByDomain" class="col-xs-3 col-xl-2 filter">
                        <mat-form-field class="filter__name">
                            <mat-select [placeholder]="filterByDomain['default'] | translate" class="" (selectionChange)="setFilter($event.value, filterByDomain['key'])">
                                <mat-option *ngFor="let element of filterByDomain['elements']" value="{{ element['id'] }}" [selected]="element['id'].toLocaleString() === searchInfo[filterByDomain['key']]">
                                    {{ element['name_' + itemLanguage] }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!--search filters-->
                    <div *ngIf="filterByDomain" class="col-xs-3 col-xl-2 filter">
                        <mat-form-field class="filter__language">
                            <mat-select (selectionChange)="filterLanguage($event.value)" [value]="languages[0]['locale']">
                                <mat-option *ngFor="let language of languages;"
                                    [selected]="language['locale'] === itemLanguage"
                                    [value]="language['locale']">
                                    {{ language.name | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-xs-2 offset-xs-5 col-xl-2 offset-xl-0">
                        <button type="button" (click)="searchItems()" class="btn btn-primary btn-block ">
                        <i class="fas fa-search"></i>
                        {{ 'Search' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table--grid">
            <div class="table--grid__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }} header" (click)="sort(column);">

                                <ng-container *ngIf="column[3] === 'name'; else headerTemp">
                                    <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0] + itemLanguage, 'asc': order === 'asc', 'desc': order === 'desc'}">
                                        {{ column[1] | translate }} {{ itemLanguage }}
                                    </span>
                                </ng-container>
                                <ng-template #headerTemp>
                                    <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                        {{ column[1] | translate }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>

                <!--table cells-->
                <ng-container *ngIf="items && items.length; else emptySymptom">
                    <ng-container *ngFor="let symptom of items">

                        <div class="row" [class.inactive]="symptom.deleted_at && symptom.deleted_at !== null">
                            <!--group header button for table-->
                            <div class="col-xs-12" (click)="openFormModal({ action: 'read', feeling_system_id: symptom['feeling_system_id'], title: 'Symptom Details', activated: symptom['activated'], content: symptom['activated'] ? 'Are you sure you want to deactivate this symptom?' : 'Are you sure you want to activate this symptom?', description: symptom['name'], url: '/symptoms' });">
                                <div class="row">
                                    <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                        <ng-template [ngIf]="column[4] !== 'translation'" [ngIfElse]="isTranslateColumn">
                                            <ng-template [ngIf]="column[4] === 'boolean'">
                                                {{ (symptom[column[0]] === 0 ? 'No' : 'Yes') | translate}}
                                            </ng-template>
                                            <ng-template [ngIf]="column[4] !== 'boolean'">
                                                {{ symptom[column[0]] | translate }}
                                            </ng-template>
                                        </ng-template>
                                        <ng-template #isTranslateColumn>
                                            {{ symptom[column[0] + itemLanguage]}}
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-3 table--grid__actions table--grid__actions--hover">
                                <div class="btn-group dropdown" dropdown>
                                    <button class="btn btn-link table--grid__actions__ellipsis dropdown-toggle" dropdownToggle>
                                        <i class="fas fa-ellipsis-h table--grid__actions__ellipsis__icon"
                                           aria-hidden="true"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right table--grid__actions__links">
                                        <li class="dropdown-item"
                                            (click)="openFormModal({
                                                            action: 'update',
                                                            languages: languages,
                                                            id: symptom['feeling_system_id'],
                                                            title: 'Update Symptom' , url: 'symptoms'});">
                                            <a class="btn btn-link table--grid__action-btn">
                                                <i class="fas fa-pencil-alt table--grid__actions__links__icon" aria-hidden="true"
                                                   title="{{ 'Edit' | translate }}"
                                                   attr.name="{{ 'Edit' | translate }}"></i>
                                            </a>
                                        </li>
                                        <li class="dropdown-item" (click)="deleteSymptom(symptom)">
                                            <a class="btn btn-link table--grid__action-btn">
                                                <i class="far fa-trash-alt table--grid__actions__links__icon"
                                                   title="{{ 'Delete' | translate }}"
                                                   attr.name="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                
                <ng-template #emptySymptom>
                    <div class="text-xs-center pd-v--sm">
                        {{ 'No item is matched your search criteria.' | translate }}
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <!--pagination-->
    <pagination-component *ngIf="!paginationHidden"
                          [(page)]="currentPage"
                          [total]="totalItems"
                          [perPage]="itemsPerPage"
                          [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)" #pagination>

    </pagination-component>
    <div class="mt-1 mb-1"></div>
    <!-- Modal -->
    <div bsModal #modal="bs-modal" class="modal fade" [ngClass]="params['action'] === 'activate' || params['action'] === 'delete' ? 'modal-confirmation': ''" tabindex="-1" role="dialog" aria-hidden="true">

        <div class="modal-dialog">
            <symptoms-modal-component
                [item]="item"
                [itemLanguage]="itemLanguage"
                [standards]="standards"
                [symptoms]="symptoms"
                [domains]="domains"
                [neutral_system_ids]="neutral_system_ids"
                [symptomsByDomain]="symptomsByDomain"
                [indicators]="indicatorsReference"
                [params]="params"
                [formLoading]="formLoading"
                [form]="form"
                [formSubmitted]="formSubmitted"
                [languages]="languages"
                [authService]="authService"
                [token]="token"
                [helpRawData]="helpSymptomProfile"
                (hideModal)="hideModal()"
                (switchLanguage)="switchLanguage($event)"
                (submit)="submit(form.value, form.valid, url, true)"
                (openFormModal)="openFormModal({ action: 'update', id: params['feeling_system_id'], title: 'Update Symptom', url: 'symptoms' })"
                (activateConfirmationModal)="openConfirmModal({
                    url: 'symptoms',
                    action: 'activate',
                    feeling_system_id: params['id'],
                    activated: params['activated'],
                    title: params['activated'] == 1 ? 'Deactivate Symptom Account' : 'Activate Symptom Account',
                    content: params['content'],
                    description: params['description'],
                    icon: params['activated'] == 1 ? 'fas fa-ban':'far fa-check-circle'
                })"
                (delete)="deleteSymptom(params)"
                >
            </symptoms-modal-component>
        </div>
    </div>
    <!--close <div bsModal ...-->

    <div bsModal #modalDeleteSymptom="bs-modal" class="modal fade modal-confirmation modal-delete-symptom" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-confirmation-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-body text-xs-center">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="modal-icon">
                                <i class="far fa-trash-alt" ng-class="icon" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 modal-title">
                            {{ 'Delete symptom confirmation' | translate }}
                        </div>
                        <div class="col-xs-12 modal-content">
                            {{ 'Are you sure you want to delete this symptom?' | translate }}
                            <br/>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-xs-12 text-xs-right">
                            <button type="button" class="btn btn-secondary " (click)="this.modalDeleteSymptom.hide()">
                                <i class="fas fa-ban"></i>
                                {{ 'Cancel' | translate }}
                            </button>
                            <button type="button" class="btn btn-primary " (click)="submitDeleteSymptom()">
                                <i class="fas fa-check"></i>
                                {{ 'OK' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<dialog-component #dialog></dialog-component>
<dialog-component #dialogLogo></dialog-component>
